var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"page-wrapper full-page"},[_vm._m(0),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"noble-ui-logo d-block mx-4 mt-4",attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("@/assets/images/wappin-logo.png"),"height":"40"}})])
}]

export { render, staticRenderFns }